export default "__VITE_ASSET__DI2pLkmd__"